const { REACT_APP_REST_ENDPOINT } = process.env;
const VETRINA_ENDPOINT = `${REACT_APP_REST_ENDPOINT}/vetrina`;

const VetrinaService = {

    _handleJsonResponse: async (response) => {
        if (response.ok) {
            const text = await response.text();
            return text ? JSON.parse(text) : {};
        } else {
            const error = await response.json().catch(() => ({ message: `Errore del server: ${response.statusText}` }));
            throw new Error(error.message || "Si è verificato un errore");
        }
    },

    getVetrina() {
        const token = localStorage.getItem("token");
        return fetch(`${VETRINA_ENDPOINT}/get-vetrina`, {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` }
        }).then(this._handleJsonResponse);
    },

    getPromozioni(data) {
        const token = localStorage.getItem("token");
        return fetch(`${VETRINA_ENDPOINT}/get-promozioni`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data)
        }).then(this._handleJsonResponse);
    },

    createPromozione(data) {
        const token = localStorage.getItem("token");
        return fetch(`${VETRINA_ENDPOINT}/create-promozione`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data)
        }).then(this._handleJsonResponse);
    },

    updatePromozione(data) {
        const token = localStorage.getItem("token");
        return fetch(`${VETRINA_ENDPOINT}/update-promozione`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data)
        }).then(this._handleJsonResponse);
    },

    deletePromozione(data) {
        const token = localStorage.getItem("token");
        return fetch(`${VETRINA_ENDPOINT}/delete-promozione`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data)
        }).then(this._handleJsonResponse);
    }
};

export default VetrinaService;